export default { version: '2.8.2' };
